import { Button } from '@repo/ui/components/ui/button';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@repo/ui/components/ui/dropdown-menu';

import { type Comment_Sort } from '@repo/api/open-calls/graphql';
import { DropdownMenu } from '@repo/ui/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useComments } from '../../../../../../../apps/web/src/state/use-comments';
import {
  ALL_SCORES_SORT_BUTTON_TEST_ID,
  ALL_SCORES_SORT_CREATE_AT_DESC_OPTION,
  ALL_SCORES_SORT_DROPDOWN_CONTENT_TEST_ID,
  ALL_SCORES_SORT_OPTIONS,
} from '../../../../constants/all-scores-sort-options';

interface Props {
  submissionId: string;
  dataPermission: string;
}

const AllScoreSortDropdown = ({ submissionId, dataPermission }: Props) => {
  const { fetchComments } = useComments();
  const [sort, setSort] = useState(
    ALL_SCORES_SORT_CREATE_AT_DESC_OPTION.sortBy,
  );

  const handleSortChange = useCallback(
    async (option: Comment_Sort) => {
      await fetchComments({
        orderBy: option,
        submissionID: submissionId,
      });
      setSort(option as Comment_Sort);
    },
    [fetchComments, submissionId],
  );

  const placeholder = ALL_SCORES_SORT_OPTIONS.find(
    (option) => option.sortBy === sort,
  )?.label;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          data-testid={ALL_SCORES_SORT_BUTTON_TEST_ID}
          data-permission={dataPermission}
        >
          {placeholder}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-56"
        data-testid={ALL_SCORES_SORT_DROPDOWN_CONTENT_TEST_ID}
      >
        <DropdownMenuLabel className="px-3 py-1.5 font-semibold text-sm">
          Sort by
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="border-t" />
        {ALL_SCORES_SORT_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.testId}
            data-testid={option.testId}
            className="px-3 py-1.5"
            onClick={() => handleSortChange(option.sortBy as Comment_Sort)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AllScoreSortDropdown;
